import love_hate from './love-hate';
import core_viz from './core-viz';
import community from './community';
import lang from './lang';
import routine from './routine';
import header from './header';
import util from './_utils';
import social from './social';

const svg = d3.select('.svg__love-hate');

let tooltipShown = false;

// add your dropdown id here
const dropdownIDs = ['dropdown-age', 'dropdown-sex', 'dropdown-nationality'],
	langDropdownIDs = ['lang-dropdown-age', 'lang-dropdown-sex', 'lang-dropdown-nationality']

const dataSources = {
	'age': [{
		id: 'Under 35',
		text: 'Under 35'
	}, {
		id: '35-44',
		text: '35 - 44'
	}, {
		id: '45-54',
		text: '45 - 54'
	}, {
		id: '55+',
		text: '55+'
	}],
	'sex': [{
		id: 'M',
		text: 'Male'
	}, {
		id: 'F',
		text: 'Female'
	}],
	'nationality': [{
		id: 'Australia',
		text: 'Australian'
	}, {
		id: 'Brazil',
		text: 'Brazilian'
	}, {
		id: 'Canada',
		text: 'Canadian'
	}, {
		id: 'France',
		text: 'French'
	}, {
		id: 'Germany',
		text: 'German'
	}, {
		id: 'Japan',
		text: 'Japanese'
	}, {
		id: 'Spain',
		text: 'Spanish'
	}, {
		id: 'UK',
		text: 'British'
	}, {
		id: 'USA',
		text: 'American'
	}]
}

function translateDropdowns() {
	dataSources.age.forEach(d => {
		d.text = lang.translateViz('dropdown', `Age--${d.id}`);
	});
	dataSources.sex.forEach(d => {
		d.text = lang.translateViz('dropdown', `Sex--${d.id}`);
	});
	dataSources.nationality.forEach(d => {
		d.text = lang.translateViz('dropdown', `Nationality--${d.id}`);
	});
}

//filters selected in dropdowns currently
let filtersSelected = {
	age: 'Total',
	sex: 'Total',
	nationality: 'Total',
}

//personalization filters
let personalized = false,
	filtered = false,
	filteredToPersonalize = false,
	personalizationSelected = {
		age: 'Total',
		sex: 'Total',
		nationality: 'Total',
	}

//keep track of what chapter we're on so we know what to update
let currentChapter = 'landing';

function init() {
	return new Promise((resolve, reject) => {
		translateDropdowns();
		// activatePersonalize();
		activateSelect2();
		resolve();

		$('#personalize-save-button').on('click', () => {
			savePersonalize();
		});

		$('#personalize-reset-button').on('click', () => {
			resetPersonalize();
		});

		$('.page--language .personalize-button').on('click', () => {
			savePersonalize();
		});

		$('.page--personalize .personalize-button').on('click', () => {
			activatePersonalize(true);
		});

		d3.selectAll('.personalize-button-tooltip').on('click', () => {
			d3.selectAll('.personalize-button-tooltip').classed('is-visible', false);
			tooltipShown = true;
		});
	})
}

function resize() {
	//clearSelect2();
	//./activateSelect2();
	//checkSelect2()
}

function clearSelect2() {
	dropdownIDs.forEach((id) => {
		$(`#${id}`).each(function() {
			$('select', this).select2('destroy')
		});
	})
}

function savePersonalize() {
	if (filtered) {
		setPersonalize();
		d3.select('.people-like-me').classed('is-active', true);
		$('.personalize-button').toggleClass('is-active', true);
		header.toggleLanguage(false);
	}
}

function setPersonalize() {
	personalizationSelected.age = filtersSelected.age;
	personalizationSelected.sex = filtersSelected.sex;
	personalizationSelected.nationality = filtersSelected.nationality;
	personalized = true;
}

function resetPersonalize() {
	set('', '', '');

	personalizationSelected.age = filtersSelected.age;
	personalizationSelected.sex = filtersSelected.sex;
	personalizationSelected.nationality = filtersSelected.nationality;

	personalized = false;
	filtered = false;

	d3.selectAll('.personalize-button').classed('is-active', false);
}

function setAsPersonalized() {
	updateCurrentViz();
}

function activatePersonalize(fromHeader = false) {
	d3.selectAll('.personalize-button-tooltip').classed('is-visible', false);
	const filtersVisible = d3.select('.page--personalize').classed('is-visible');

	if (!filtersVisible && personalized) {
		set(personalizationSelected.sex, personalizationSelected.nationality, personalizationSelected.age);
		$('.personalize-button').toggleClass('is-filtered', true);
		updateCurrentViz();
	} else if (filtersVisible) {
		setPersonalize();
		set(personalizationSelected.sex, personalizationSelected.nationality, personalizationSelected.age);
		$('.personalize-button').toggleClass('is-filtered', true);
		$('.personalize-button').toggleClass('is-active', true);
	} else if (!personalized) {
		header.toggleFilters(true)
		if (fromHeader) util.changeVisibility(['.page--personalize', '.header-button-personalize', '.header-button-personalize-close'], [true, false, true]);
	} else {
		set(personalizationSelected.sex, personalizationSelected.nationality, personalizationSelected.age);
		$('.personalize-button').toggleClass('is-filtered', true);
		updateCurrentViz();
	}

	if (!tooltipShown) d3.selectAll('.personalize-button-tooltip').classed('is-visible', true);

	/*
	if (!personalized && filtered) {
		savePersonalize()
		setAsPersonalized();
		d3.selectAll('.personalize-button').classed('is-active', true);
		d3.selectAll('.personalize-button').classed('is-filtered', true);
		d3.selectAll('.select2-selection__clear').html(`<img inline src='./assets/images/icons/strava-close.svg'>`);
		//filteredToPersonalize = true;
	} else if (personalized) {
		d3.selectAll('.personalize-button').classed('is-active', true);
		d3.selectAll('.personalize-button').classed('is-filtered', true);
		d3.selectAll('.select2-selection__clear').html(`<img inline src='./assets/images/icons/strava-close.svg'>`);
		set(personalizationSelected.sex, personalizationSelected.nationality, personalizationSelected.age);
		savePersonalize();
		setAsPersonalized();
		//filteredToPersonalize = true;
	} else if (!filtered) {
		header.toggleFilters(true)
		if (fromHeader) util.changeVisibility(['.page--personalize', '.header-button-personalize', '.header-button-personalize-close'], [true, false, true]);
		d3.selectAll('.personalize-button-tooltip').classed('is-visible', true);
	}
	*/
}

function deactivatePersonalize(fromHeader = false) {
	//clear();
	//updateCurrentViz();
	d3.selectAll('.personalize-button').classed('is-filtered', false);
	//filteredToPersonalize = false;
}

function activateSelect2() {
	dropdownIDs.forEach((id) => {
		$(`#${id}`).each(function() {
			$('select', this).select2({
				placeholder: lang.translateViz('dropdown', `Placeholder--${$(this).attr('data-placeholder')}`),
				minimumResultsForSearch: -1,
				allowClear: true,
				data: dataSources[$(this).attr('data-source')],
				width: $(this).width(),
				height: $(this).height(),
			});
		})

		// add functions here
		$(`#${id}`).on('select2:open', function(e) {})
			.on('select2:close', function(e) {})
			.on('select2:select', function(e) {
				svg.selectAll('.bubble').style('pointer-events', 'none');
				const value = e.params.data.id;
				d3.select(`#${id}`).selectAll('.select2-selection__rendered, .select2-container').classed('is-active', true);
				d3.select(`#${id}`).select('.select2-selection__clear').html(`<img inline src='./assets/images/icons/strava-close.svg'>`);
				updateFilters(id, value);
				deactivatePersonalize();
			}).on('select2:clear', () => {
				updateFilters(id, 'Total');
				d3.select(`#${id}`).selectAll('.select2-selection__rendered, .select2-container').classed('is-active', false);
				deactivatePersonalize();
			});
	})

	langDropdownIDs.forEach((id) => {
		$(`#${id}`).each(function() {
			$('select', this).select2({
				placeholder: lang.translateViz('dropdown', `Placeholder--${$(this).attr('data-placeholder')}`),
				minimumResultsForSearch: -1,
				allowClear: true,
				data: dataSources[$(this).attr('data-source')],
				width: $(this).width(),
				height: $(this).height(),
			});
		})

		// add functions here
		$(`#${id}`).on('select2:select', function(e) {
			const value = e.params.data.id;
			d3.select(`#${id}`).selectAll('.select2-selection__rendered, .select2-container').classed('is-active', true);
			d3.select(`#${id}`).select('.select2-selection__clear').html(`<img inline src='./assets/images/icons/strava-close.svg'>`);
			// d3.select('.people-like-me').classed('is-active', true);
			updateFilters(id, value, false);
			deactivatePersonalize();
		}).on('select2:clear', function(e) {
			updateFilters(id, 'Total', false);
			d3.select(`#${id}`).selectAll('.select2-selection__rendered, .select2-container').classed('is-active', false);
			deactivatePersonalize();
			// d3.select('.people-like-me').classed('is-active', false);

			// how to stop the dropdown showing on clear??
		});
	})
}

//update viz from filters
function updateFilters(id, value, updateViz = true) {
	if (id === 'dropdown-age' || id === 'lang-dropdown-age') filtersSelected.age = value;
	if (id === 'dropdown-sex' || id === 'lang-dropdown-sex') filtersSelected.sex = value;
	if (id === 'dropdown-nationality' || id === 'lang-dropdown-nationality') filtersSelected.nationality = value;

	if (filtersSelected.age == 'Total' && filtersSelected.sex == 'Total' && filtersSelected.nationality == 'Total') {
		filtered = false;
	} else {
		filtered = true;
	}

	// if (filtered && !personalized) d3.selectAll('.personalize-button-tooltip').classed('is-visible', true);

	if (updateViz) updateCurrentViz();
}

function updateCurrentViz() {
	//based on current chapter
	if (currentChapter == 'love-hate') love_hate.filter(filtersSelected);
	if (currentChapter == 'core-viz') core_viz.filter(filtersSelected.sex, filtersSelected.nationality, filtersSelected.age);
	if (currentChapter == 'community') community.filter(filtersSelected);
	if (currentChapter == 'routine') routine.filter(null, null, filtersSelected.sex, filtersSelected.age, filtersSelected.nationality);
}

//TOGGLE ACTIVE VS INACTIVE ON FILTERS
function toggle(chapter, index) {
	let personalizeActive = false,
		socialActive = false,
		filteredToPersonalize = false;

	//first index in chapter is -1 when you're clicking next / prev
	personalizeActive = personalizeActiveSteps[chapter][index + 1];
	socialActive = socialActiveSteps[chapter][index + 1];

	const currentLang = lang.getCurrentLang();
	if (currentLang != 'en-US' && chapter === 'aspirations') socialActive = false;

	$('.page--personalize').toggleClass('is-down', personalizeActive || socialActive);
	$('.page--personalize').toggleClass('is-active', false);
	$('.page--personalize').toggleClass('is-visible', false);
	$('.personalize-button').toggleClass('is-filtered', false);

	$('.header-button-personalize').toggleClass('is-active', personalizeActive);
	$('.page--personalize__outside--personalize').toggleClass('is-visible', personalizeActive);

	$('.page--personalize__outside--share').toggleClass('is-visible', socialActive);
	$('.header-button-personalize').css('pointer-events', personalizeActive ? 'all' : 'none');

	social.hide();
	header.toggleFilters();
	header.togglePersonalize(false);

	currentChapter = chapter;

	if (personalizeActive && !tooltipShown && !personalized) {
		d3.selectAll('.personalize-button-tooltip').classed('is-visible', true);
		tooltipShown = true;
	} else {
		d3.selectAll('.personalize-button-tooltip').classed('is-visible', false);
	}

}

function get() {
	return {
		'personalization': personalizationSelected,
		'filters': filtersSelected,
	}
}

function set(sex, nationality, age) {
	age = age == 'Total' ? '' : age
	sex = sex == 'Total' ? '' : sex
	nationality = nationality == 'Total' ? '' : nationality

	d3.selectAll('.select2-selection__clear').html(`<img inline src='./assets/images/icons/strava-close.svg'>`);

	if (sex) {
		filtersSelected.sex = sex;
		$('#dropdown-sex select').val(sex).trigger('change');
		$('#lang-dropdown-sex select').val(sex).trigger('change');
		makeActive(['lang-dropdown-sex', 'dropdown-sex']);
	} else {
		filtersSelected.sex = 'Total';
		$('#dropdown-sex select').val('').trigger('change');
		$('#lang-dropdown-sex select').val('').trigger('change');
		makeInactive(['lang-dropdown-sex', 'dropdown-sex']);
	}

	if (nationality) {
		filtersSelected.nationality = nationality;
		$('#dropdown-nationality select').val(nationality).trigger('change');
		$('#lang-dropdown-nationality select').val(nationality).trigger('change');
		makeActive(['lang-dropdown-nationality', 'dropdown-nationality']);
	} else {
		filtersSelected.nationality = 'Total';
		$('#dropdown-nationality select').val('').trigger('change');
		$('#lang-dropdown-nationality select').val('').trigger('change');
		makeInactive(['lang-dropdown-nationality', 'dropdown-nationality']);
	}

	if (age) {
		filtersSelected.age = age;
		$('#dropdown-age select').val(age).trigger('change');
		$('#lang-dropdown-age select').val(age).trigger('change');
		makeActive(['lang-dropdown-age', 'dropdown-age']);
	} else {
		filtersSelected.age = 'Total';
		$('#dropdown-age select').val('').trigger('change');
		$('#lang-dropdown-age select').val('').trigger('change');
		makeInactive(['lang-dropdown-age', 'dropdown-age']);
	}
}

function makeActive(id) {
	id.forEach(d => {
		$(`#${d} .select2-selection__rendered`).addClass('is-active');
		$(`#${d} .select2-container`).addClass('is-active');
	})
}

function makeInactive(id) {
	id.forEach(d => {
		$(`#${d} .select2-selection__rendered`).removeClass('is-active');
		$(`#${d} .select2-container`).removeClass('is-active');
	})
}

function clear() {
	set('Total', 'Total', 'Total');

	dropdownIDs.forEach(id => {
		d3.select(`#${id}`).select('.select2-selection__rendered').classed('is-active', false);
	})
}

const personalizeActiveSteps = {
	//only two states for love-hate: inactive before final step, active on final step
	'love-hate': [false, false, false, false, false, true],
	'core-viz': [false, false, true],
	'health': [false, false, false, false, false],
	'community': [true, false, false, true, true],
	'routine': [true, true, true, true],
	'aspirations': [false, false, false],
}

const socialActiveSteps = {
	//only two states for love-hate: inactive before final step, active on final step
	'love-hate': [false, false, true, false, true, true],
	'core-viz': [true, true, true],
	'health': [false, true, true, true, true],
	'community': [true, true, true, true, true],
	'routine': [true, true, true, true],
	'aspirations': [true, true, true],
}

export default {
	init,
	resize,
	toggle,
	get,
	set,
	clear,
};